import React from "react";
import { Grid, Segment } from "semantic-ui-react";
import ChannelInfo from "./ChannelInfo";
import PopularVideos from "./PopularVideos";
const YouTube = () => (
  <Segment inverted>
    <Grid inverted verticalAlign="middle">
      <ChannelInfo />
      <PopularVideos />
    </Grid>
  </Segment>
);

export default YouTube;
